import { z } from 'zod';
import { Image } from './ImageSchema';

// eslint-disable-next-line no-shadow
enum BuyOptions {
  buy = 'buy',
  rent = 'rent',
  buynrent = 'buynrent',
}

// eslint-disable-next-line no-shadow
export enum PropertyType {
  house = 'house',
  apartment = 'apartment',
}

export type BuyOptionsEnum = z.infer<typeof BuyOptionsEnum>;
export const BuyOptionsEnum = z.nativeEnum(BuyOptions);

export type PropertyTypeEnum = z.infer<typeof PropertyTypeEnum>;
export const PropertyTypeEnum = z.nativeEnum(PropertyType);

export type Property = z.infer<typeof Property>;
export const Property = z.object({
  id: z.number(),
  name: z.string(),
  buyOptions: BuyOptionsEnum,
  rooms: z.number(),
  area: z.number(),
  description: z.string(),
  price: z.string(),
  floor: z.string(),
  stairs: z.string(),
  flatNumber: z.string(),
  type: PropertyTypeEnum,
  parent: z.any(),
  images: z.array(Image),
  interfaceName: z.string().optional(),
  interfaceId: z.string().optional(),
  updatedAt: z.date(),
});
